import React from 'react';
import Wizard from '../Wizard/Wizard';
import { useOutcomeWizardContext } from './OutcomeWizardProvider';
import {
  outcomesPendoKeys,
  outcomesWizardConfig,
} from './OutcomesWizardConfig';
import { useReviewFeaturesContext } from 'contexts/ReviewFeaturesProvider';

const OutcomeWizard: React.FC = () => {
  const outcomeWizard = useOutcomeWizardContext();
  const { hasSelectableMeasures } = useReviewFeaturesContext();

  return (
    <Wizard
      id="outcomes-wizard"
      data={outcomesWizardConfig(hasSelectableMeasures)}
      pendoKey={outcomesPendoKeys}
      isOpen={outcomeWizard.isWizardOpen}
      onClose={() => {
        outcomeWizard.setWizardHasBeenDisplayed(true);
        outcomeWizard.setWizardOpen(false);
      }}
    />
  );
};

export default OutcomeWizard;
